/**
 * Logique pure de la sélection multiple (Lot 4).
 * rangeSelection : plage shift+clic dans l'ordre visuel de la liste.
 * resolveBulkCompleteAction : bascule intelligente Terminer/Rouvrir.
 */

export function rangeSelection(
  orderedIds: string[],
  anchorId: string | null,
  targetId: string,
): string[] {
  const targetIdx = orderedIds.indexOf(targetId);
  if (targetIdx < 0) return [];
  const anchorIdx = anchorId ? orderedIds.indexOf(anchorId) : -1;
  if (anchorIdx < 0) return [targetId];
  const [from, to] = anchorIdx <= targetIdx ? [anchorIdx, targetIdx] : [targetIdx, anchorIdx];
  return orderedIds.slice(from, to + 1);
}

export function resolveBulkCompleteAction(
  tasks: { is_completed: boolean }[],
): 'complete' | 'uncomplete' {
  return tasks.some((t) => !t.is_completed) || tasks.length === 0
    ? 'complete'
    : 'uncomplete';
}
